/* Package B (2026-09-27): slick 1.8's accessibility mode writes invalid ARIA (listbox/option/tablist roles,
   aria-controls pointing at ids that don't exist, role=presentation + aria-selected on the dot <li>s, aria-hidden on
   dot <li>s that hold focusable buttons). Screen readers and automated agents get a broken tree. After each slick
   init/change this strips those attributes and names the dots and the image-only arrows. Visual behavior unchanged. */
(() => {
  'use strict';
  const es = (document.documentElement.lang || '').toLowerCase().startsWith('es');
  const fix = slider => {
    slider.querySelectorAll(':scope > .slick-list, :scope > .slick-list > .slick-track, .slick-slide').forEach(el => {
      if (/^(listbox|option|tabpanel|presentation)$/.test(el.getAttribute('role') || '')) el.removeAttribute('role');
    });
    slider.querySelectorAll('.slick-dots').forEach(dots => {
      if (dots.hasAttribute('role')) dots.removeAttribute('role');
      dots.querySelectorAll(':scope > li').forEach((li, i) => {
        ['role', 'aria-selected', 'aria-controls', 'aria-hidden', 'id'].forEach(a => { if (li.hasAttribute(a)) li.removeAttribute(a); });
        const b = li.querySelector('button');
        if (b) {
          ['role', 'aria-controls', 'aria-selected', 'aria-labelledby'].forEach(a => { if (b.hasAttribute(a)) b.removeAttribute(a); });
          const lbl = (es ? 'Diapositiva ' : 'Slide ') + (i + 1); if (b.getAttribute('aria-label') !== lbl) b.setAttribute('aria-label', lbl);
          if (li.classList.contains('slick-active')) { if (b.getAttribute('aria-current') !== 'true') b.setAttribute('aria-current', 'true'); } else if (b.hasAttribute('aria-current')) b.removeAttribute('aria-current');
        }
      });
    });
    slider.querySelectorAll('.slick-slide[aria-describedby]').forEach(s => {
      if (!document.getElementById(s.getAttribute('aria-describedby'))) s.removeAttribute('aria-describedby');
    });
    slider.querySelectorAll('img.slick-prev, img.slick-next').forEach(img => {
      if (img.dataset.gzA11y) return;
      const prev = img.classList.contains('slick-prev'), name = prev ? (es ? 'Anterior' : 'Previous') : (es ? 'Siguiente' : 'Next');
      img.alt = name; img.dataset.gzA11y = '1';                      // a real name (alt="" would make it presentational)
      img.setAttribute('role', 'button'); img.setAttribute('tabindex', '0');
      img.addEventListener('keydown', e => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); img.click(); } });
    });
  };
  // slick re-runs initADA AFTER it fires afterChange (autoplay every few seconds), so events alone lose the race.
  // Watch each slider and re-apply on the next frame whenever slick touches these attributes; fix() only removes or
  // sets values that differ, so it settles after one pass.
  const watched = new WeakSet(), queued = new WeakSet();
  const schedule = s => { if (queued.has(s)) return; queued.add(s); requestAnimationFrame(() => { queued.delete(s); fix(s); }); };
  const watch = s => { if (watched.has(s)) return; watched.add(s); fix(s);
    new MutationObserver(() => schedule(s)).observe(s, { subtree: true, childList: true, attributes: true, attributeFilter: ['role', 'aria-selected', 'aria-controls', 'aria-hidden', 'aria-describedby', 'id', 'class'] }); };
  const sweep = () => document.querySelectorAll('.slick-initialized').forEach(watch);
  const jq = window.__gzJQ || window.jQuery;
  if (jq) jq(document).on('init reInit afterChange breakpoint', '.slick-slider', function () { const s = this; setTimeout(() => watch(s), 0); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sweep, { once: true }); else sweep();
  window.addEventListener('load', () => { sweep(); setTimeout(sweep, 1500); }, { once: true });
})();
